const addShouldDisableUnshareToAnnotation = (
  allStudentAndTeacherAnnotations,
  allAnnotationsToShow,
) => {
  const allAnnotationsWithReplies = allStudentAndTeacherAnnotations?.filter(
    (annotation) => annotation.in_response_to,
  );
  const annotationCommentIds = allAnnotationsWithReplies?.map(
    (annotation) => annotation.in_response_to.id,
  );

  allAnnotationsToShow?.forEach((annotation) => {
    if (annotationCommentIds.includes(annotation.id)) {
      annotation.hasReplies = true;
    }
  });

  return allAnnotationsToShow;
};

export default addShouldDisableUnshareToAnnotation;
